module.exports = __webpack_public_path__ + "static/img/IMG_20240210_163932.aa5a9887.jpg";